export const NUDITY_CLASSIFICATION = {
    SAFE: 0,
    HOT: 1,
    HARD: 2,
    UNIDENTIFIED: -1,
}

export const NUDITY_CLASSIFICATION_TYPE = {
    SAFE: 'safe',
    HOT: 'hot',
    HARD: 'hard',
    UNIDENTIFIED: 'unidentified',
}

export const NUDITY_CLASSIFICATION_TYPE_MAP = {
    [NUDITY_CLASSIFICATION.SAFE]: NUDITY_CLASSIFICATION_TYPE.SAFE,
    [NUDITY_CLASSIFICATION.HOT]: NUDITY_CLASSIFICATION_TYPE.HOT,
    [NUDITY_CLASSIFICATION.HARD]: NUDITY_CLASSIFICATION_TYPE.HARD,
    [NUDITY_CLASSIFICATION.UNIDENTIFIED]: NUDITY_CLASSIFICATION_TYPE.UNIDENTIFIED,
}

export const NUDITY_CLASSIFICATION_TEXT_MAP = {
    [NUDITY_CLASSIFICATION.SAFE]: gettext('Safe'),
    [NUDITY_CLASSIFICATION.HOT]: gettext('Hot'),
    [NUDITY_CLASSIFICATION.HARD]: gettext('Hard'),
    [NUDITY_CLASSIFICATION.UNIDENTIFIED]: gettext('Unidentified photo'),
}